import * as React from 'react';
import { isEqual } from 'lodash';

import { TPinObject } from '../../types/map';
import { MapContainer } from '../../ui/map/map';

import * as styles from './styles.css';

interface IMapProps {
  mapId: string;
  pins: TPinObject[];
  initialCenter: [number, number];
}

export class Map extends React.PureComponent<IMapProps> {
  private mapContainer: MapContainer;

  public async componentDidMount() {
    const { mapId, initialCenter, pins } = this.props;

    this.mapContainer = new MapContainer();

    try {
      await this.mapContainer.initialize(mapId, initialCenter);

      this.mapContainer.disable('scrollZoom');
      this.mapContainer.createPlacemarks(pins);
    } catch (err) {
      console.error(err);
    }
  }

  public componentDidUpdate(prevProps: Readonly<IMapProps>): void {
    const { pins } = this.props;

    if (!this.mapContainer || isEqual(pins, prevProps.pins)) {
      return;
    }

    this.mapContainer.updatePlacemarks(pins);
    this.updateMapPosition(pins);
  }

  public render() {
    return <div id={this.props.mapId} className={styles['container']} />;
  }

  private updateMapPosition = (pins: TPinObject[]) => {
    if (pins.length) {
      this.mapContainer.fitToPins();
    }
  };
}
